import script from "./resourcesPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./resourcesPopup.vue?vue&type=script&setup=true&lang=js"

import "./resourcesPopup.vue?vue&type=style&index=0&id=7c5dc581&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c5dc581"]])

export default __exports__